const lookupTypes = {
  GET_SYSTEM_CONFIG_LOADING: "GET_SYSTEM_CONFIG_LOADING",
  GET_SYSTEM_CONFIGURATION_SUCCESS: "GET_SYSTEM_CONFIGURATION_SUCCESS",
  GET_SYSTEM_CONFIGURATION_DETAILS_SUCCESS: "GET_SYSTEM_CONFIGURATION_DETAILS_SUCCESS",
};

export default lookupTypes;
